var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21 24a3 3 0 1 1 3 3 3 3 0 0 1-3-3Zm-9.85-6.424 9.679 4.838ZM5 16a3 3 0 1 1 3 3 3 3 0 0 1-3-3Zm15.683-6.342-9.573 4.788ZM21 8a3 3 0 1 1 3 3 3 3 0 0 1-3-3Z"
  })));
};
export default SvgShare;